// extracted by mini-css-extract-plugin
module.exports = {"dots":"styles_dots__vGuaX","dot":"styles_dot__esCT_","activeDot":"styles_activeDot__PgFO0"};